import { Directive, ElementRef, HostListener } from '@angular/core';

@Directive({
  selector: '[ebOnlyNumber]',
})
export class OnlyNumberDirective {
  constructor(private el: ElementRef) {}

  isNumeric(value: string) {
    return /^-?\d+$/.test(value);
  }

  @HostListener('paste', ['$event']) onPaste(event: ClipboardEvent) {
    let clipboardData = event.clipboardData;
    let pastedText = clipboardData.getData('text');

    if (!this.isNumeric(this.el.nativeElement.value + pastedText)) {
      event.preventDefault();
    }
  }

  @HostListener('keydown', ['$event']) onKeyDown(event) {
    const e = <KeyboardEvent>event;
    const hasModifierKey = e.ctrlKey === true || e.metaKey === true;

    //Backspace, Tab, Escape, Del, Return/enter
    if (
      [8, 9, 27, 46, 13].indexOf(e.keyCode) !== -1 ||
      // Allow: Ctrl/Cmd+A
      (e.keyCode === 65 && hasModifierKey) ||
      // Allow: Ctrl/Cmd+C
      (e.keyCode === 67 && hasModifierKey) ||
      // Allow: Ctrl/Cmd+V
      (e.keyCode === 86 && hasModifierKey) ||
      // Allow: Ctrl/Cmd+X
      (e.keyCode === 88 && hasModifierKey) ||
      // Allow: home, end, left, right
      (e.keyCode >= 35 && e.keyCode <= 39)
    ) {
      // let it happen, don't do anything
      return;
    }
    // Ensure that it is a number and stop the keypress
    // Keyboard & numpad numbers
    if ((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
      e.preventDefault();
    }
  }
}
